import { SVGS } from '@zonofi/zono-money-design-system';
import React from 'react';
import './out-of-stock-error-snackbar.scss';
interface OutOfStockErrorSnackBarProps {
  number: number;
}
export const OutOfStockErrorSnackBar: React.FC<
  OutOfStockErrorSnackBarProps
> = ({ number }) => {
  return (
    <div className="font-primary out-of-stock-error-snackbar">
      <img src={SVGS.ErrorIconRed} alt="error" />
      only {number} quantity is available
    </div>
  );
};
